import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=acbef7ec&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=acbef7ec&lang=less&scoped=true&"
import style1 from "./orderPay.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbef7ec",
  null
  
)

export default component.exports